// extracted by mini-css-extract-plugin
export default {"messages":"WIVAMessages_messages__+FplC"};